import { BaseCache, ListCache } from "../lib/SyncCache.ts";
import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";

export const GalleryListCache = new ListCache(ApiServer.albumfrontbycreator);

export const GalleryCache = new BaseCache(ApiServer.albumall);

Object.assign(ApiServer.types.IMedia.prototype,{
  getLimitedRatio(){
    var ratio = this.ratioX() || 1;
    if(ratio<0.7) ratio = 0.7;
    if(ratio>1.7) ratio = 1.7;
    return ratio;
  },
  getFlexBasis(height){
    return Math.round(height*this.getLimitedRatio())
  }
})
Object.assign(ApiServer.types.MediaFilterFrontImage.prototype,{
  onDecode(){
    switch(this.type){
      case "ALL":
        this.name = i18n.get("photos.all");
        this.canAdd = true;
        break;
      case "MOOD_STAR":
        this.name = i18n.get("photos.favorites");
        this.canAdd = false;
        break;
      case "AUTHOR":
        this.canAdd = this.authorIsMe();
        this.account = FwDatas.getProfile(this.accountId);
        this.name = this.account.name;
        break;
      default:
        return;
    }
  },
  getMediaFilter:function(media){
    switch(this.type){
      case "MOOD_STAR":
        return (media)=>Object.entries(media.moodMap).length>0;
      case "AUTHOR":
        return  (media)=>media.accountId===this.accountId
      case "ALL":
        return (media)=>true;
      default:
        console.log('unsupported type')
        return (media)=>true;
    }
  }
});